import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const templatesApiV1 = collectionEngineV1('/templates');
export const getAll = () => templatesApiV1('GET', '/');
export const del = (templateId) => templatesApiV1('DELETE', '/all/' + templateId);
export const pdfPreviewURL = (templateId, caseId, body, data, versionId) => `/templates/pdf-preview/${templateId}/${caseId}?${toQuery({
    body: body || undefined,
    data: data || undefined,
    versionId: versionId || undefined,
})}`;
export const docxPreviewURL = (templateId, caseId, body, data, versionId) => `/templates/docx-preview/${templateId}/${caseId}?${toQuery({
    body: body || undefined,
    data: data || undefined,
    versionId: versionId || undefined,
})}`;
export const create = (template) => templatesApiV1('POST', '', {
    body: template,
});
export const getTemplate = async (templateId, ac, lang, includeUnpublished) => {
    return templatesApiV1('GET', '/' +
        templateId +
        '/' +
        ac +
        `?lang=${lang}${includeUnpublished ? `&includeUnpublished=${includeUnpublished}` : ''}`);
};
export const saveDraft = async (template) => {
    return templatesApiV1('POST', '/save-draft', {
        body: template,
    });
};
export const publishVersion = async (versionId, ac, isDefaultLang) => {
    return templatesApiV1('POST', '/publish-version', {
        body: {
            versionId,
            ac,
            isDefaultLang,
        },
    });
};
export const getTemplateVersions = async (templateId, ac, lang) => {
    return templatesApiV1('POST', '/versions', { body: { templateId, ac, lang } });
};
export const deleteTemplateVersion = async (versionId, ac) => {
    return templatesApiV1('DELETE', '/version/' + versionId + '/' + ac);
};
export const patch = async (templateId, patch) => {
    return templatesApiV1('PATCH', '/' + templateId, {
        body: patch,
    });
};
//# sourceMappingURL=templates.js.map